import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";

export default function usePlan() {
  const [data, setData] = useState<{ plan: string; usage: { messages_processed: number; products_synced: number }; year_month: string } | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    setLoading(true);

    (async () => {
      try {
        const now = new Date();
        const ym = `${now.getUTCFullYear()}-${String(now.getUTCMonth() + 1).padStart(2, "0")}`;

        // Read user's plan
        const { data: planRow, error: planErr } = await supabase.from("user_plans").select("plan").maybeSingle();
        if (planErr) throw planErr;
        const plan = planRow?.plan ?? "free";

        // Read user's usage for current month
        const { data: usageRow, error: usageErr } = await supabase
          .from("user_usage")
          .select("messages_processed, products_synced")
          .eq("year_month", ym)
          .maybeSingle();
        if (usageErr) throw usageErr;

        if (!mounted) return;
        setData({ plan, usage: usageRow ?? { messages_processed: 0, products_synced: 0 }, year_month: ym });
      } catch (err) {
        if (!mounted) return;
        setError(err instanceof Error ? err.message : String(err));
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  return { data, loading, error } as const;
}
